<script>
  export let title = "default title";
</script>

<div class="main-title">
  <h2>{title}</h2>
</div>
